<template>
  <section id="Popular" class="mt-1 mb-2">
    <div class="text-right cursor--pointer pr-1" @click="closeTab()">
      <i class="fa fa-times-circle"></i> Sulje
    </div>
    <div class="c-header--label text-white mb-1">Lähetä palautetta, kehitysideoita tai ilmoita virheestä</div>
    <form @submit.prevent="emailFeedback" class="mr-1">
      <div class="form-group">
        <label for="subject" class="text-white">Aihe</label>
        <select v-model="form.subject" class="form-control" id="subject">
          <option>Kehitysidea</option>
          <option>Tuote- tai hintavirhe</option>
          <option>Järjestelmävirhe</option>
          <option>Muu palaute</option>
        </select>
      </div>
      <div class="form-group">
        <label for="message" class="text-white">Viesti</label>
        <textarea v-model="form.message" class="form-control" id="message" rows="3"></textarea>
      </div>
      <div class="form-group">
        <label for="name" class="text-white">Nimi</label>
        <input v-model="form.name" type="text" class="form-control" id="name">
      </div>
      <div class="form-group">
        <label for="email" class="text-white">Sähköpostiosoite</label>
        <input v-model="form.email" type="email" class="form-control" id="email">
      </div>
      <button type="submit" class="btn btn-sm btn-t1-primary mt-1"><i class="fa fa-paper-plane" aria-hidden="true"></i> Lähetä</button>
      <div v-if="emailSuccess" class="alert alert-success mt-2" role="alert">
        Viesti lähetetty.
      </div>
    </form>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Feedback',

  data () {
    return {
      form: {
        subject: null,
        message: null,
        name: null,
        email: null
      },
      emailSuccess: false
    }
  },

  watch: {
    // clear emailSuccess if form is changed
    form: {
      handler (val) {
        if (this.emailSuccess === true) {
          this.emailSuccess = false
        }
      },
      deep: true
    }
  },

  methods: {
    emailFeedback: function () {
      const p = [this.form.subject, this.form.message, this.form.name, this.form.email].join(';')
      const self = this
      axios
        .post(process.env.VUE_APP_PROD_PHP_BACKEND + '/feedback_mailer.php', p)
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            self.emailSuccess = true // show success message
          }
        })
        .catch(error => { console.log(error) })
    },

    closeTab: function () {
      this.$emit('closeTab', true)
    }
  }
}
</script>
